@if (question) { @if (question.isCountingDown) {
<qa-countdown> </qa-countdown>
} @if (!question.isCountingDown) {
<div class="inner">
  <div class="left flex-column">
    <ng-scrollbar data-check="true" class="text">
      @if (question.model.media?.uuid) {
      <img
        src="{{ 'mediaUrl' | env }}/{{ question.model.media.uuid }}.{{
          question.model.media.file_ext
        }}"
        class="image"
      />
      }
      <qa-markdown-katex [data]="question.model.text"> </qa-markdown-katex>
      <div class="answers">
        <qa-question-answers
          [disabled]="
            answersDisabled ||
            question.isAnswered ||
            question.isCompleted ||
            question.isDisabled
          "
          [control]="answerSelectionControl"
          [question]="question.model"
          [showCorrectAnswers]="question.isCompleted"
          [trueFalseOrderInverted]="question.trueFalseOrderInverted"
        >
        </qa-question-answers>
        @if (!answersDisabled) { @if (!question.isAnswered &&
        !question.isCompleted) {
        <button
          (click)="submitAnswer()"
          [disabled]="isSubmitAnswerDisabled"
          class="submit-answer-button"
          color="primary"
          mat-button
          type="button"
          data-cy="logInAnswer"
        >
          <mat-icon> done </mat-icon>
          {{ 'question.label.submitAns' | translate }}
        </button>
        } @if ( !isAnswerRetractionDisabled && question.isAnswered &&
        !question.isCompleted ) {
        <button
          (click)="retractAnswer()"
          class="retract-answer-button"
          color="primary"
          mat-button
          type="button"
        >
          <mat-icon> edit </mat-icon>
          {{ 'question.label.editAns' | translate }}
        </button>
        } }
      </div>
    </ng-scrollbar>
  </div>
  <div class="right">
    <ng-scrollbar>
      <qa-play-timer [showLargeTimer]="true"></qa-play-timer>
      <qa-play-timer class="small-mobile-only"></qa-play-timer>
      <div class="submitted-answers">
        <div class="progress">
          <div class="top">
            <div class="position">
              {{ answerSubmitted | number : '2.0-0' }} /
              {{ numOfUsers | number : '2.0-0' }}
              {{ 'question.label.answersSubmitted' | translate }}
            </div>
          </div>
          <mat-progress-bar
            [value]="getProgressAnswer(answerSubmitted, numOfUsers)"
            color="primary"
          >
          </mat-progress-bar>
        </div>
      </div>
    </ng-scrollbar>
  </div>
  @if (isCompleted) {
  <div class="explanation-panel qa-theme-inverted">
    <ng-scrollbar class="scroll-container">
      <div class="correct-incorrect">
        <mat-icon>
          {{ isAnsweredCorrectly ? 'done' : 'clear' }}
        </mat-icon>
        {{
          (isAnsweredCorrectly
            ? 'question.label.correct'
            : isAnsweredIncorrectly
            ? 'question.label.inCorrect'
            : 'question.label.notAnswered'
          ) | translate
        }}
      </div>
      @if (question.isExplanationPanelOpen) {
      <div class="correct-answer-text">{{ getCorrectAnswerText() }}</div>
      @if (question.model.type !== questionType.TrueFalse) {
      <ul>
        @for (correctAnswer of getCorrectAnswers(); track correctAnswer.id) {
        <li>
          <qa-markdown-katex [data]="correctAnswer.text"> </qa-markdown-katex>
        </li>
        }
      </ul>
      }
      <qa-markdown-katex [data]="question.model.explanation">
      </qa-markdown-katex>
      }
    </ng-scrollbar>
    <div class="actions">
      @if (!data.hideWeblink && getWeblink()) {
      <a
        [href]="getWeblink()"
        color="primary"
        mat-button
        target="_blank"
        type="button"
      >
        <mat-icon>open_in_new</mat-icon>
        {{ 'question.openWebLink' | translate }}
      </a>
      }
      <button
        (click)="
          question.isExplanationPanelOpen = !question.isExplanationPanelOpen
        "
        class="toggle-explanation-button"
        color="primary"
        mat-button
        type="button"
      >
        <mat-icon>arrow_back_ios</mat-icon>
        <span class="bttntext">{{
          (question.isExplanationPanelOpen
            ? 'question.label.showQuestion'
            : 'question.label.showExplanation'
          ) | translate
        }}</span>
      </button>
    </div>
  </div>
  }
</div>
}
<div [matRippleDisabled]="true" #submitAnswerRipple matRipple></div>
}
